import styled from "styled-components"
import { colors } from "../../lib/colors"
import { tabletLargeText } from "../../media_queries/TabletMediaQueries"
interface coeficient_props {
  textTransform?: string
  size?: string
  lineheight?: string
}
interface main_board_props {
  removeComponent?: boolean
  jackpotType?: boolean
  jackpotPopup?: boolean
}
export const TextInfoWrapper = styled.div`
  position: absolute;
  top: 112px;
  right: 50%;
  transform: translateX(50%);
  .jackpot-title {
    text-transform: uppercase;
    font-size: 16px;
    color: #868b9e;
    @media only screen and (min-width: 768px) {
      font-size: 24px;
    }
    @media only screen and (min-width: 1024px) and (max-height: 640px) {
      font-size: 20px;
    }
  }
  .jackpot-text {
    text-transform: uppercase;
    font-size: 44px;
    line-height: 1;
    @media only screen and (min-width: 768px) {
      font-size: 48px;
    }
    @media only screen and (min-width: 1024px) and (max-height: 640px) {
      font-size: 34px;
    }
  }

  @media only screen and (min-width: 768px) {
    top: 138px;
  }
  @media only screen and (min-width: 1024px) {
    top: 80px;
  }
  @media only screen and (min-width: 1024px) and (max-height: 920px) {
    top: 14px;
  }
  @media only screen and (min-width: 1024px) and (max-height: 640px) {
    top: 10px;
  }
`
export const Title = styled.div<{ anim?: boolean }>`
  text-transform: uppercase;
  color: #868b9e;
  font-size: 16px;
  text-align: center;
  line-height: 1;
  ${tabletLargeText}
  @media only screen and (min-width: 768px) {
    font-size: 24px;
  }
  @media only screen and (min-width: 1024px) and (max-height: 640px) {
    font-size: 20px;
  }
`

export const MainBoard = styled.div<main_board_props>`
  display: flex;
  position: relative;
  height: ${({ jackpotPopup }) => (jackpotPopup ? "0" : "465px")};
  width: 100%;
  @media only screen and (min-width: 768px) {
    height: ${({ jackpotPopup }) => (jackpotPopup ? "0" : "610px")};
  }
  @media only screen and (min-width: 1024px) {
    height: unset;
  }
  .info {
    opacity: ${({ removeComponent }) => (removeComponent ? 0 : 1)};
    transition: opacity 3s;
  }
`

export const Coeficient = styled.div<coeficient_props>`
  font-size: 44px;
  /* text-shadow: 0px 4px 14px rgba(0, 0, 0, 0.25); */
  background: ${colors.redGradient};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  clip-path: inset(1px 0.5px);
  text-align: center;
  margin-top: -5px;
  line-height: 1;
  font-family: "SemiBold";
  text-transform: ${({ textTransform }) => textTransform};
  @media only screen and (min-width: 768px) {
    font-size: 48px;
  }
  @media only screen and (min-width: 1024px) and (max-height: 640px) {
    font-size: 34px;
  }
`
